import { lazy } from "react";

const Story = lazy(() => import("./story"));
const StoryWall = lazy(() => import("./storyWall"));
const TandCStory = lazy(() => import("./T&C/TandC"));
export { Story, StoryWall, TandCStory };
